const TID_KEY = "ca_password_reset_tid";
const EMAIL_KEY = "ca_password_reset_email";

/** Pending password change after login (`passwordResetRequired`) or before profile load. */
export interface CaPasswordResetSession {
  email: string;
  /** Present only for forgot-password OTP flow if stored here; forced login usually has no tid. */
  tid?: string;
}

export function setCaPasswordResetSession(email: string, tid?: string): void {
  sessionStorage.setItem(EMAIL_KEY, email);
  if (tid) {
    sessionStorage.setItem(TID_KEY, tid);
  } else {
    sessionStorage.removeItem(TID_KEY);
  }
}

export function getCaPasswordResetSession(): CaPasswordResetSession | null {
  const email = sessionStorage.getItem(EMAIL_KEY);
  if (!email) {
    return null;
  }
  const tid = sessionStorage.getItem(TID_KEY);
  return tid ? { email, tid } : { email };
}

export function clearCaPasswordResetSession(): void {
  sessionStorage.removeItem(TID_KEY);
  sessionStorage.removeItem(EMAIL_KEY);
}
